module.exports = __webpack_public_path__ + "img/ayhf.f1c645ec.jpg";